import { fetchQueueForProvider } from "actions/customerService";
import { setQueueActivityState } from "actions/queue";
import { eUserType } from "constants";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const StartProviderQueue = () => {

    const userDetail = useSelector(state => state.user.userDetail);
    const dispatch = useDispatch();

    const [queueData, setQueueData] = useState();

    const getQueueData = async (providerId) => {
        const fetchedQueue = await fetchQueueForProvider(providerId)
        setQueueData(fetchedQueue);
    }

    const startProviderQueueOnLoad = async (providerId, orgId) => {
        //Start queue service
        if (providerId && orgId) {
            let payload = {
                counterId: "",
                providerId: providerId,
                queueActivityState: true
            }
            //alert("Startinug queue");
            await setQueueActivityState(orgId, payload)
        }
    }

    useEffect(() => {
        if (userDetail.id && userDetail.userType == eUserType.provider) {
            getQueueData(userDetail.id);
        }
    }, [userDetail]);

    useEffect(() => {
        if (queueData && !queueData?.queueStarted && !queueData?.active) {
            startProviderQueueOnLoad(userDetail?.id, userDetail?.providerInformation?.organizationId);
        }
    }, [queueData]);

    return null;
}

export default StartProviderQueue;